// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ed05cf24","821":"3eb2aba8","899":"150dee5d"}[chunkId] + ".chunk.js";
};